"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    display: table-cell;\n    padding: ", "em\n        ", "em;\n    text-align: ", ";\n    font-weight: ", ";\n    border-right: ", "\n        ", " solid;\n    cursor: pointer;\n    position: relative;\n    &:last-child {\n        border-right: none;\n    }\n    ", ";\n    ", ";\n"], ["\n    display: table-cell;\n    padding: ", "em\n        ", "em;\n    text-align: ", ";\n    font-weight: ", ";\n    border-right: ", "\n        ", " solid;\n    cursor: pointer;\n    position: relative;\n    &:last-child {\n        border-right: none;\n    }\n    ", ";\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  background: ", ";\n                  border-bottom-color: ", ";\n              "], ["\n                  color: ", ";\n                  background: ", ";\n                  border-bottom-color: ", ";\n              "]),
    _templateObject3 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  background: ", ";\n              "], ["\n                  color: ", ";\n                  background: ", ";\n              "]),
    _templateObject4 = _taggedTemplateLiteral(["\n            &:not(:last-child):after{\n                content '", "';\n                height: ", "em;\n                padding: 0 ", "em;\n                border: ", ";\n                color: ", ";\n                background: ", ";\n                font-size: ", "em;\n                line-height: ", "em;\n                border-radius: ", "em;\n                position: absolute;\n                right: 0;\n                top: 50%;\n                z-index: 2;\n                transform: translate(50%, -50%);\n            }\n    "], ["\n            &:not(:last-child):after{\n                content '", "';\n                height: ", "em;\n                padding: 0 ", "em;\n                border: ", ";\n                color: ", ";\n                background: ", ";\n                font-size: ", "em;\n                line-height: ", "em;\n                border-radius: ", "em;\n                position: absolute;\n                right: 0;\n                top: 50%;\n                z-index: 2;\n                transform: translate(50%, -50%);\n            }\n    "]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Tab = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.tabordion.padding / 2;
}, function (props) {
    return props.theme.tabordion.padding;
}, function (props) {
    return props.theme.tabordion.tabs.textAlign;
}, function (props) {
    return props.theme.tabordion.fontWeight;
}, function (props) {
    return props.theme.tabordion.borderThickness;
}, function (props) {
    return props.theme.tabordion.borderColor;
}, function (props) {
    return props.current == props.i ? (0, _styledComponents.css)(_templateObject2, function (props) {
        return props.theme.tabordion.active.color;
    }, function (props) {
        return props.theme.tabordion.active.background;
    }, function (props) {
        return props.theme.tabordion.active.background;
    }) : (0, _styledComponents.css)(_templateObject3, function (props) {
        return props.theme.tabordion.default.color;
    }, function (props) {
        return props.theme.tabordion.default.background;
    });
}, function (props) {
    return props.divider && (0, _styledComponents.css)(_templateObject4, function (props) {
        return props.divider;
    }, function (props) {
        return props.theme.tabordion.dividers.height;
    }, function (props) {
        return props.theme.tabordion.dividers.padding;
    }, function (props) {
        return props.theme.tabordion.dividers.border;
    }, function (props) {
        return props.theme.tabordion.dividers.color;
    }, function (props) {
        return props.theme.tabordion.dividers.background;
    }, function (props) {
        return props.theme.tabordion.dividers.fontSize;
    }, function (props) {
        return props.theme.tabordion.dividers.height;
    }, function (props) {
        return props.theme.tabordion.dividers.radius;
    });
});

Tab.displayName = "Tab";

Tab.propTypes = {
    /** A unique key for this tab */
    index: _propTypes2.default.number,
    /** The key of the tab that is currently active */
    current: _propTypes2.default.number,
    /** Text to display in the divider. Hides divider if not active */
    divider: _propTypes2.default.string
};

exports.default = Tab;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/tabs/tab.js
// module id = 1020
// module chunks = 95715928098905 168707334958949